import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToolReturn } from "@models/tool-return.model";
import { TableConfig } from "@app/shared/util/table-config.utils";
import { Log } from "ng2-logger";
import { ToolRequestStatus } from "@app/tool/model/enums/tool-request-status.enum";

@Component({
    selector: 'app-tool-returns-facilities-table',
    templateUrl: './tool-returns-facilities-table.component.html',
    styleUrls: ['./tool-returns-facilities-table.component.scss']
})
export class ToolReturnsFacilitiesTableComponent {
    _logger = Log.create(ToolReturnsFacilitiesTableComponent.name);
    @Input() toolReturns: ToolReturn[] = [];
    @Input() tableConfig: TableConfig;
    @Input() isLoading = false;
    @Input() statusFilters = [];
    @Input() headerBackgroundColor: string;
    @Input() hasTitle = true;
    @Input() isMaterial = true;

    @Output() pageChange = new EventEmitter<any>();
    @Output() filterChange = new EventEmitter<any>();
    @Output() sortChange = new EventEmitter<any>();
    @Output() actionClick = new EventEmitter<any>();


    onPageChange(tableConfig: TableConfig) {
        this._logger.info('onPageChange', this.tableConfig);
        this.pageChange.emit(tableConfig);
    }

    onSortChange(tableConfig: TableConfig) {
        this._logger.info('onSortChange', this.tableConfig);
        this.sortChange.emit(tableConfig);
    }

    onFilterChange(tableConfig: TableConfig) {
        this._logger.info('onFilterChange', this.tableConfig);
        this.filterChange.emit(tableConfig);
    }

    onActionClick(rowData: any, startProcess: boolean) {
        this._logger.info('onActionClick', {rowData: rowData, startProcess: startProcess});
        this.actionClick.emit({toolReturn: rowData, startProcess: startProcess});
    }

    isDelivered(toolReturn) {
        return toolReturn.status === ToolRequestStatus.DELIVERED;
    }

    isWaitingForApproval(toolReturn) {
        return toolReturn.status === ToolRequestStatus.WAITING_FOR_APPROVAL;
    }
}
